// Ca 2026-08-19 (máy Windows): `avatar doctor` báo "import token_reader hỏng
// (ModuleNotFoundError) — thử `avatar sync`" và người dùng sync mãi không hết. Sync
// KHÔNG bao giờ sửa được: file tải về đúng byte, thứ thiếu là `fcntl` — module stdlib
// CHỈ có trên POSIX. Chỉ dẫn cũ vì thế đẩy người đọc vào vòng lặp vô ích.
//
// Tách khỏi `telemetry-delivery-probe.ts` để file đó khỏi phình quá 200 dòng, cùng lý
// do đã tách `telemetry-delivery-probe-python-source.ts`.

// Stdlib CPython chỉ dựng trên POSIX. Thiếu một trong số này KHÔNG phải pack hỏng —
// là chạy sai hệ điều hành, và không lệnh nào của `avatar` sửa được.
const POSIX_ONLY_STDLIB = new Set(["fcntl", "pwd", "grp", "termios", "resource", "posix"]);

/**
 * Dựng câu chỉ dẫn cho nhánh `pack_import_failed`.
 *
 * Ba ca phân biệt được (probe bản cũ không gửi `missing_module` ⇒ ca 3 là fallback,
 * KHÔNG được suy đoán thay):
 *  1. Thiếu module POSIX-only  → nói thẳng là vấn đề hệ điều hành, cấm gợi ý sync.
 *  2. Thiếu module khác        → nêu ĐÚNG TÊN module rồi mới gợi ý sync.
 *  3. Không biết thiếu gì      → giữ chỉ dẫn cũ.
 */
export function describeProbeImportFailure(
  errorType: string | undefined,
  missingModule: string | null | undefined,
): string {
  const t = errorType ?? "unknown";

  if (missingModule && POSIX_ONLY_STDLIB.has(missingModule)) {
    return (
      `Pack cài đúng, nhưng thiếu module \`${missingModule}\` — đây là stdlib CHỈ có trên ` +
      "macOS/Linux, Python trên Windows không có. `avatar sync` KHÔNG sửa được (file tải " +
      "về đã đúng). Telemetry hiện chưa chạy trên Windows; báo team pack."
    );
  }

  if (missingModule) {
    return `Pack có nhưng import token_reader hỏng (${t}: thiếu \`${missingModule}\`) — thử \`avatar sync\`.`;
  }

  return `Pack có nhưng import token_reader hỏng (${t}) — thử \`avatar sync\`.`;
}
